/**
 * Constants used in the App
 *  (ie: endpoints, images, ...)
 */

export const parameters = {
    debug: 'debug'
};

export const endpoints = {
    login: '/gsuite/domain/login'
};

export const requestParams = {
    loginConnectAccount: 'LoginConnectAccount'
};

export const loginBannerMap = {
    0: 'NoError',
    1: 'GoogleSSOPersonalAccountNotAllowed',
    2: 'GoogleSSODisabled',
    3: 'GoogleSSONoAccountsFound',
    4: 'GoogleSSONoAccountsFoundChromebook',
    5: 'GoogleSSOMoreThanOneAccounts',
};

export const messages = {
    errorInitGoogleApi: 'An error occurred when initialising Google Api. Type: {errorType}, Details: {errorDetails}',
};
